import { useCallback, useEffect, useState } from 'react';
/** Minimal data-fetch hook — no react-query dependency. */
export function useAsync(fn, deps = []) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const run = useCallback(() => {
        setLoading(true);
        setError(null);
        fn().then((d) => setData(d)).catch((e) => setError(e instanceof Error ? e.message : 'Request failed')).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    useEffect(() => { run(); }, [run]);
    return { data, loading, error, reload: run };
}
export const usd = (n) => n == null ? '—' : '$' + Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtDate = (s) => s ? new Date(s).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—';
